import React from 'react';
import { Menu } from '@uncinc/react-drupal-core';
import c from 'classnames';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import MenuItem from './MenuItem';

import './style.scss';

const MainMenu = ({ path }) => {
  const classNames = c('NavigationMenu');

  return (
    <div className={classNames}>
      <Container>
        <div className="row">
          <div className="col-12">
            <Menu id="main">
              {(items) => {
                return (
                  <ul className="NavigationMenu__items">
                    {items.map((item) => {
                      const href = item.getIn(['link', 'url'], '');
                      const title = item.getIn(['link', 'title'], 'Untitled');

                      return (
                        <MenuItem key={`menu-item-${title}:${href}`} item={item} path={path} />
                      );
                    })}
                  </ul>
                );
              }}
            </Menu>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default MainMenu;
